import { render, staticRenderFns } from "./useradmin.vue?vue&type=template&id=129532da&scoped=true&"
import script from "./useradmin.vue?vue&type=script&lang=js&"
export * from "./useradmin.vue?vue&type=script&lang=js&"
import style0 from "./useradmin.vue?vue&type=style&index=0&id=129532da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129532da",
  null
  
)

export default component.exports